import { LVTMetricData, LVTMetric } from '../metrics/types';
import { LVT_METRIC_EVENT } from '../metrics/constants';

const sendEvent = <T extends string>(event: T, data: unknown): void => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, data });
};

const checkLVTMetricEventExistence = (
  stepName: NonNullable<LVTMetricData<keyof LVTMetric>['eventStep']>
): boolean => {
  window.dataLayer = window.dataLayer || [];
  return !!window.dataLayer.find((i) => {
    const metric = i as {
      event: string;
      data: { eventStep: NonNullable<LVTMetricData<keyof LVTMetric>> };
    };
    return (
      metric?.event === LVT_METRIC_EVENT && metric?.data?.eventStep === stepName
    );
  });
};

export default { sendEvent, checkLVTMetricEventExistence };
